import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useSession } from './sessionContext';
 
const PersonContext = createContext();
 
export const PersonProvider = ({ children }) => {
  const { session } = useSession();
  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);
 
  useEffect(() => {
    const userId = session?.user?.id;
    if (!userId) {
      setPerson(null);
      setLoading(false);
      return;
    }
 
    let active = true;
    setLoading(true);
 
    supabase
      .from('person')
      .select('full_name, role')
      .eq('id', userId)
      .single()
      .then(({ data, error }) => {
        if (!active) return;
        if (error) {
          console.error('Error fetching person:', error.message);
          setPerson(null);
        } else {
          setPerson(data);
        }
        setLoading(false);
      });
 
    return () => {
      active = false;
    };
  }, [session?.user?.id]);
 
  return (
    <PersonContext.Provider value={{ person, loading }}>
      {children}
    </PersonContext.Provider>
  );
};
 
export const usePerson = () => useContext(PersonContext);